exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("@tencent/docs-design-resources/pc/svg/vip_diamond_normal.svg"));

// Module
exports.push([module.id, ".anonymous-view-vip-icon{background-image:url(" + ___CSS_LOADER_URL___0___ + ");background-repeat:no-repeat;background-position:50%;background-size:contain;width:20px;height:20px;display:inline-block;margin-right:6px}", ""]);

